import React, { ReactNode } from "react";
import st from "./index.module.scss";

type Props = {
  rightIcon: ReactNode;
};

const HomePageHeroImg = (props: Props) => {
  return (
    <div className={st.innerContent}>
      <div className={st.rightSide}>{props.rightIcon}</div>
    </div>
  );
};

export default HomePageHeroImg;
